import React from 'react';
import useTestimonialContainerData from './useTestimonialContainerData';

interface ITestimonialContainerProps {
  component?: React.ComponentType<React.PropsWithChildren<any>>;
  className?: string;
  hideLoader?: boolean;
  url?: string;
  testimonials?: any[];
}

const TestimonialContainer: React.FC<React.PropsWithChildren<ITestimonialContainerProps>> = ({
  component: Component,
  className = '',
  hideLoader = false,
  url,
  testimonials = [],
}) => {
  const existingTestimonials = testimonials || [];
  const fetch = !existingTestimonials.length;
  const { testimonials: fetchedTestimonials } = useTestimonialContainerData(
    url,
    { hideLoader, fetch }
  );

  return (
    (!!(existingTestimonials.length || fetchedTestimonials?.length) && (
      <section className={className}>
        {!!Component && (
          <Component
            testimonials={
              (existingTestimonials.length && existingTestimonials) ||
              fetchedTestimonials
            }
          />
        )}
      </section>
    )) ||
    null
  );
};
export default React.memo(TestimonialContainer);
